import React, { Component } from 'react';

import PaginationComponent from './PaginationComponent';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { Calendar } from 'primereact/calendar';
import dateFormat from 'dateformat';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';
import { openInvoiceFile } from '../utils/invoiceFile';

var config = process.env;

class TableInvoiceComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sourceLimit: 1000,
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'cfeDate',
            sortDir: 'desc',
            data: [],
            loaded: false,
            // Arranca en el mes corriente: con mes elegido el backend trae el mes ENTERO de PYMO
            // (el tope de "Cargar" no aplica) y la sumatoria no depende de cuántas haya encima.
            dateSelected: new Date(),
            // { porMes, completo } del backend; completo=false = la sumatoria puede ser parcial.
            summaryScope: null,
            summary: {
                all: { total: 0, totalSinIVA: 0, iva: 0, count: 0 },
                byType: {},
            },
        };
    }

    componentDidMount() {
        this.loadInvoices();
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    getSelectedMonth = () => {
        if (!this.state.dateSelected) {
            return {};
        }

        return {
            month: this.state.dateSelected.getMonth() + 1,
            year: this.state.dateSelected.getFullYear(),
        };
    }

    getSummaryByType = (cfeType) => {
        if (cfeType === 0) {
            return this.state.summary?.all || { total: 0, totalSinIVA: 0, iva: 0, count: 0 };
        }
        return this.state.summary?.byType?.[String(cfeType)] || { total: 0, totalSinIVA: 0, iva: 0, count: 0 };
    }

    loadInvoices = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        sourceLimit = this.state.sourceLimit,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        const { month, year } = this.getSelectedMonth();
        const query = buildPaginationQuery({
            page,
            limit,
            search,
            sortBy,
            sortDir,
            extraParams: {
                month,
                year,
            },
        });

        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}invoice/list/${sourceLimit}?${query}`, request)
            .then(results => results.json())
            .then(data => {
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                    return;
                }

                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    sourceLimit: Number(sourceLimit),
                    summary: data.data.summary || {
                        all: { total: 0, totalSinIVA: 0, iva: 0, count: 0 },
                        byType: {},
                    },
                    summaryScope: data.data.summaryScope || null,
                    loaded: true,
                });
            });
    }

    drawRow = (item, index) => {
        return(
            <tr role="row" className="odd" key={item._id} style={{ background: index % 2 == 0 ? '#ffffff' : '#fcfcfc' }}>
                <td>{item.clientEmissionId}</td>
                <td>{item.cfeTypeLabel}</td>
                <td>{dateFormat(item.cfeDate, 'dS mmmm, yyyy - HH:MM')}</td>
                <td>{item.serie} {item.nro}</td>
                <td>$ {Number(item.totalAmount || 0).toLocaleString('de-DE')}</td>
                <td>{item.actualCfeStatus}</td>
                <td>
                    <div className="btn-group btn-group-sm" role="group" aria-label="Table row actions">
                        <button
                            onClick={() => this.onViewInvoice(item._id)}
                            type="button"
                            className="btn btn-white">
                            <i className="material-icons">search</i>
                        </button>
                    </div>
                </td>
            </tr>
        );
    }

    renderEmptyState = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div style={{ textAlign: 'center', maxWidth: '420px' }}>
                    <div
                        style={{
                            width: '72px',
                            height: '72px',
                            margin: '0 auto 1rem',
                            borderRadius: '50%',
                            background: '#f5f6f8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="material-icons" style={{ fontSize: '34px', color: '#818ea3' }}>description</i>
                    </div>
                    <h4 style={{ marginBottom: '0.75rem', color: '#3d5170', fontWeight: 500 }}>
                        Todavia no hay facturas emitidas para mostrar
                    </h4>
                    <p style={{ margin: 0, color: '#818ea3', lineHeight: 1.6 }}>
                        Cuando existan facturas para el periodo seleccionado, aca vas a ver el listado
                        con tipo, fecha, monto, estado y acceso al comprobante.
                    </p>
                </div>
            </div>
        );
    }

    renderLoader = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    onViewInvoice = (invoiceId) => {
        openInvoiceFile('invoice/file/' + invoiceId);
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty">
                    <td colSpan="7" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                        {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                    </td>
                </tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.loadInvoices({ page: 1, limit: itemSelected });
    }

    onChangeLoadRows = () => {
        const itemSelected = Number(document.getElementById('load_rows').value);
        this.loadInvoices({ page: 1, sourceLimit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.loadInvoices({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.loadInvoices({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    onSetDate = (value) => {
        this.setState({ dateSelected: value }, () => {
            this.loadInvoices({ page: 1 });
        });
    }

    // Qué cubre la sumatoria. Un total parcial mostrado como final fue lo que hizo ver $776k de
    // $1,07M facturados en setiembre 2026: si puede faltar algo, se dice.
    renderSummaryScope = () => {
        const scope = this.state.summaryScope;
        if (!this.state.loaded || !scope) {
            return null;
        }
        if (scope.completo) {
            return (
                <span className="text-muted d-block text-center" style={{ marginTop: '10px', fontSize: '13px' }}>
                    {scope.porMes ? 'Incluye todos los comprobantes del mes.' : 'Incluye todos los comprobantes emitidos.'}
                </span>
            );
        }
        return (
            <div className="alert alert-warning text-center" role="alert" style={{ marginTop: '10px', marginBottom: 0 }}>
                {scope.porMes
                    ? 'Atención: no se pudo traer el mes completo desde el facturador. La sumatoria puede ser parcial.'
                    : `Atención: la sumatoria es sólo de las últimas ${this.state.sourceLimit} facturas emitidas, no de todas. Elegí un mes para ver su total completo.`}
            </div>
        );
    }

    renderGenericData = () => {
        const all = this.getSummaryByType(0);
        const etickets = this.getSummaryByType(101);
        const efacturas = this.getSummaryByType(111);

        return(
            <div className="col-lg-12">
                <div className="card card-small mb-4">
                    <div className="card-header border-bottom">
                        <h6 className="m-0">Sumatoria</h6>
                    </div>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item p-3">
                            <div className="row">
                                <div className="col">
                                    <div className="form-group col-md-12">
                                        <div className="row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <span style={{ display: 'block' }}>Mes a sumar</span>
                                        </div>
                                        <div className="row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px' }}>
                                            <Calendar value={this.state.dateSelected} onChange={(e) => this.onSetDate(e.value)} view="month" dateFormat="mm/yy" showButtonBar />
                                        </div>
                                        {this.renderSummaryScope()}
                                    </div>
                                    <div className="row ">
                                        <div className="col-md-4">
                                            <span className="text-muted d-block mb-2 text-center">Sumatoria total</span>
                                            <div className="d-flex align-items-center" style={{ gap: '3px', fontSize: '20px' }}>
                                                <label htmlFor="date">Total facturado sin IVA:</label>
                                                <span style={{ marginLeft: '30px' }} className="text-muted d-block mb-2">$ {Number(all.totalSinIVA || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                            </div>
                                            <div className="d-flex align-items-center" style={{ gap: '3px', fontSize: '20px' }}>
                                                <label htmlFor="user">IVA total:</label>
                                                <span style={{ marginLeft: '30px' }} className="text-muted d-block mb-2">$ {Number(all.iva || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                            </div>
                                            <div className="d-flex align-items-center" style={{ gap: '3px', fontSize: '20px' }}>
                                                <label htmlFor="date">Total facturado con IVA:</label>
                                                <span style={{ marginLeft: '30px' }} className="text-muted d-block mb-2">$ {Number(all.total || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                            </div>
                                            <div className="d-flex align-items-center" style={{ gap: '3px', fontSize: '20px' }}>
                                                <label htmlFor="user"># de emisiones:</label>
                                                <span style={{ marginLeft: '30px' }} className="text-muted d-block mb-2">{all.count || 0}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <span className="text-muted d-block mb-2 text-center">E-tickets</span>
                                            <div className="d-flex align-items-center" style={{ gap: '3px', fontSize: '20px' }}>
                                                <label htmlFor="date">Total facturado con iva:</label>
                                                <span style={{ marginLeft: '30px' }} className="text-muted d-block mb-2">$ {Number(etickets.total || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                            </div>
                                            <div className="d-flex align-items-center" style={{ gap: '3px', fontSize: '20px' }}>
                                                <label htmlFor="user"># e-tickets:</label>
                                                <span style={{ marginLeft: '30px' }} className="text-muted d-block mb-2">{etickets.count || 0}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <span className="text-muted d-block mb-2 text-center">E-facturas</span>
                                            <div className="d-flex align-items-center" style={{ gap: '3px', fontSize: '20px' }}>
                                                <label htmlFor="date">Total facturado con iva:</label>
                                                <span style={{ marginLeft: '30px' }} className="text-muted d-block mb-2">$ {Number(efacturas.total || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                            </div>
                                            <div className="d-flex align-items-center" style={{ gap: '3px', fontSize: '20px' }}>
                                                <label htmlFor="user"># e-facturas:</label>
                                                <span style={{ marginLeft: '30px' }} className="text-muted d-block mb-2">{efacturas.count || 0}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.renderGenericData()}
                {!this.state.loaded ? this.renderLoader() : null}
                {this.state.loaded && this.state.totalItems === 0 && !hasActiveSearch(this.state.searchInput, this.state.search) ? this.renderEmptyState() : null}
                {this.state.loaded && (this.state.totalItems > 0 || hasActiveSearch(this.state.searchInput, this.state.search)) ? (
                <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                    <div className="three_in_row dataTables_length" id="DataTables_Table_2_length">
                        {/* Con mes elegido se traen todas las del mes: el tope sólo vale sin mes. */}
                        {this.state.dateSelected ? <label>Todas las facturas del mes</label> : null}
                        <label style={this.state.dateSelected ? { display: 'none' } : undefined}>Cargar
                        <select id="load_rows" name="DataTables_Table_3_length" aria-controls="DataTables_Table_0" value={this.state.sourceLimit} onChange={() => this.onChangeLoadRows()}>
                            <option value="0">Todas</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                        </select>
                        facturas</label>
                    </div>
                    <div className="three_in_row dataTables_length" id="DataTables_Table_0_length">
                        <label>Mostrar
                        <select id="select_rows" name="DataTables_Table_1_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                        </select>
                        facturas por página</label>
                    </div>
                    <div id="DataTables_Table_0_filter" className="three_in_row dataTables_filter">
                        <label>Search:
                        <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                        </label>
                    </div>

                    <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                        <thead>
                            <tr role="row">
                                <th {...this.sortableHeader('clientEmissionId')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Purchase</th>
                                <th {...this.sortableHeader('cfeTypeLabel')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Tipo</th>
                                <th {...this.sortableHeader('cfeDate')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '20%' }}>Fecha</th>
                                <th {...this.sortableHeader('nro')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Nro factura</th>
                                <th {...this.sortableHeader('totalAmount')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Monto</th>
                                <th {...this.sortableHeader('actualCfeStatus')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Estado</th>
                                <th tabIndex="0" aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Acciones</th>
                            </tr>
                        </thead>
                        {this.loadData()}
                    </table>

                    <PaginationComponent
                        totalItems={this.state.totalItems}
                        quantityRows={this.state.quantityShowRows}
                        currentPage={this.state.currentPage}
                        onPageChange={(page) => this.loadInvoices({ page })}
                    />
                </div>
                ) : null}
            </div>
        );
    }
}

export default TableInvoiceComponent;
